import type { SocialLinkType } from "@/lib/directus/typeGuards";

export const HEADER_SOCIAL_SERVICES = ["telegram", "vk", "max"] as const;

export type HeaderSocialService = (typeof HEADER_SOCIAL_SERVICES)[number];

const SERVICE_ALIASES: Record<string, HeaderSocialService> = {
  telegram: "telegram",
  tg: "telegram",
  vk: "vk",
  vkontakte: "vk",
  max: "max",
};

export function normalizeSocialService(service: string): string {
  const key = service.toLowerCase().trim();
  return SERVICE_ALIASES[key] ?? key;
}

export function getHeaderSocialLinks(
  links: SocialLinkType[] | null | undefined
): SocialLinkType[] {
  if (!links) {
    return [];
  }

  const linksByService = new Map<string, SocialLinkType>();

  for (const link of links) {
    const normalizedService = normalizeSocialService(link.service);
    if (!linksByService.has(normalizedService)) {
      linksByService.set(normalizedService, {
        ...link,
        service: normalizedService,
      });
    }
  }

  return HEADER_SOCIAL_SERVICES.map((service) => linksByService.get(service))
    .filter((link): link is SocialLinkType => Boolean(link?.url));
}
